const map = {
	"./braj-ke-bhakt-part-1/bhakt-dadar-rahman-mathura-vrindavan.json": [
		1528,
		[
			9052
		]
	],
	"./braj-ke-bhakt-part-1/bhakt-shri-bholanath-ji-bhori-sakhi.json": [
		8647,
		[
			8513
		]
	],
	"./braj-ke-bhakt-part-1/bhakt-shri-navalkishore-das-ji-nandgaon.json": [
		5169,
		[
			7671
		]
	],
	"./braj-ke-bhakt-part-1/goswami-shri-galluji-maharaj-vrindavan.json": [
		837,
		[
			3634
		]
	],
	"./braj-ke-bhakt-part-1/musalman-bhakt-gulab-sakhiji-barsana.json": [
		5168,
		[
			5840
		]
	],
	"./braj-ke-bhakt-part-1/nandgram-ke-mahatma-aur-pujari-bhoot-lila.json": [
		6622,
		[
			6996
		]
	],
	"./braj-ke-bhakt-part-1/pandit-ramkrishna-das-babaji-antim-lila.json": [
		1439,
		[
			4397
		]
	],
	"./braj-ke-bhakt-part-1/pandit-ramkrishna-das-babaji-vrindavan.json": [
		2714,
		[
			6030
		]
	],
	"./braj-ke-bhakt-part-1/shri-advaitdas-babaji-govardhan.json": [
		8643,
		[
			7721
		]
	],
	"./braj-ke-bhakt-part-1/shri-anantdas-babaji-karhala.json": [
		8866,
		[
			4378
		]
	],
	"./braj-ke-bhakt-part-1/shri-avadhdas-babaji-vrindavan.json": [
		1959,
		[
			4163
		]
	],
	"./braj-ke-bhakt-part-1/shri-durgi-maa-ki-katha.json": [
		6405,
		[
			8683
		]
	],
	"./braj-ke-bhakt-part-1/shri-gaurangdas-babaji-vrindavan-jivani.json": [
		2306,
		[
			6896
		]
	],
	"./braj-ke-bhakt-part-1/shri-gaurangdas-babaji-vrindavan.json": [
		6168,
		[
			4500
		]
	],
	"./braj-ke-bhakt-part-1/shri-jagdishdas-babaji-vrindavan.json": [
		8023,
		[
			5259
		]
	],
	"./braj-ke-bhakt-part-1/shri-kripasindhudas-babaji-vrindavan.json": [
		111,
		[
			3639
		]
	],
	"./braj-ke-bhakt-part-1/shri-krishna-prem-aur-bhikharin-bhakt.json": [
		4085,
		[
			7503
		]
	],
	"./braj-ke-bhakt-part-1/shri-krishna-prem-ronald-nixon-aur-ma-yashoda.json": [
		1400,
		[
			8706
		]
	],
	"./braj-ke-bhakt-part-1/shri-lalababu-ki-katha.json": [
		8990,
		[
			6098
		]
	],
	"./braj-ke-bhakt-part-1/shri-lalit-kishori-ji-aur-lalit-madhuri-ji.json": [
		1900,
		[
			5936
		]
	],
	"./braj-ke-bhakt-part-1/shri-phool-babaji-vrindavan.json": [
		5977,
		[
			4935
		]
	],
	"./braj-ke-bhakt-part-1/shri-pramanand-goswamiprabhupad-vairagya-aur-dainya.json": [
		5585,
		[
			3923
		]
	],
	"./braj-ke-bhakt-part-1/shri-priyasharan-babaji-vrindavan.json": [
		4135,
		[
			1961
		]
	],
	"./braj-ke-bhakt-part-1/shri-ramdas-kathiyababa-vrindavan.json": [
		5653,
		[
			631
		]
	],
	"./braj-ke-bhakt-part-1/shri-sachinandandas-babaji-barsana.json": [
		7566,
		[
			8138
		]
	],
	"./braj-ke-bhakt-part-1/shri-santdas-kathiyababa-vrindavan.json": [
		4133,
		[
			841
		]
	],
	"./braj-ke-bhakt-part-1/shri-shyamdas-baba-ki-katha.json": [
		5617,
		[
			8159
		]
	],
	"./braj-ke-bhakt-part-1/shri-swami-baldevdas-ji-vrindavan.json": [
		3927,
		[
			7237
		]
	],
	"./braj-ke-bhakt-part-1/shri-swami-rupmadhurisharan-ji-vrindavan.json": [
		749,
		[
			3169
		]
	],
	"./braj-ke-bhakt-part-1/shri-vrindavan-das-baba-ki-katha.json": [
		1323,
		[
			9975
		]
	],
	"./braj-ke-bhakt-part-1/shripad-brahmanand-goswami-prabhu.json": [
		4767,
		[
			2145
		]
	],
	"./braj-ke-bhakt-part-1/shripad-navkishore-goswami-aur-lochananand-goswami.json": [
		7723,
		[
			9223
		]
	],
	"./braj-ke-bhakt-part-1/sri-balramdas-babaji-vrindavan-lila.json": [
		8419,
		[
			4989
		]
	],
	"./braj-ke-bhakt-part-1/sri-durlabhdas-babaji-govindkund-lila.json": [
		6402,
		[
			9012
		]
	],
	"./braj-ke-bhakt-part-1/sri-gaordas-babaji-lila.json": [
		3587,
		[
			2769
		]
	],
	"./braj-ke-bhakt-part-1/sri-gaurcharan-das-babaji-lila.json": [
		7611,
		[
			4187
		]
	],
	"./braj-ke-bhakt-part-1/sri-haridas-babaji-vrindavan-lila.json": [
		9302,
		[
			7220
		]
	],
	"./braj-ke-bhakt-part-1/sri-jaykrishna-das-babaji-lila.json": [
		6553,
		[
			769
		]
	],
	"./braj-ke-bhakt-part-1/sri-krishnadas-babaji-govardhan-lila.json": [
		4907,
		[
			8215
		]
	],
	"./braj-ke-bhakt-part-1/sri-krishnadas-babaji-ranwari-lila.json": [
		199,
		[
			8855
		]
	],
	"./braj-ke-bhakt-part-1/sri-madhavdas-babaji-vrindavan-lila.json": [
		6235,
		[
			253
		]
	],
	"./braj-ke-bhakt-part-1/sri-madhusudan-das-babaji-lila.json": [
		9683,
		[
			6151
		]
	],
	"./braj-ke-bhakt-part-1/sri-nityanand-das-babaji-brahmakund-lila.json": [
		5117,
		[
			4869
		]
	],
	"./braj-ke-bhakt-part-1/sri-radharaman-ghosh-bhagavatbhushan-lila.json": [
		3421,
		[
			6307
		]
	],
	"./braj-ke-bhakt-part-1/sri-sitanathas-babaji-govardhan-lila.json": [
		8983,
		[
			4495
		]
	],
	"./braj-ke-bhakt-part-1/srinandkishore-das-goswami-lila.json": [
		7208,
		[
			3586
		]
	],
	"./braj-ke-bhakt-part-1/swami-shri-krishnananddas-ji-hindol.json": [
		8799,
		[
			5973
		]
	],
	"./braj-ke-bhakt-part-2/badam-ke-siddh-baba-aur-jagdananddas.json": [
		3233,
		[
			8333
		]
	],
	"./braj-ke-bhakt-part-2/bhakt-shri-jyotiram.json": [
		928,
		[
			8774
		]
	],
	"./braj-ke-bhakt-part-2/bhaktimati-shri-anandi-bai.json": [
		845,
		[
			329
		]
	],
	"./braj-ke-bhakt-part-2/bhaktimati-shri-lalitabai.json": [
		1280,
		[
			7326
		]
	],
	"./braj-ke-bhakt-part-2/bhaktraj-shri-mansingh-rajawat.json": [
		472,
		[
			4236
		]
	],
	"./braj-ke-bhakt-part-2/brahmachari-shri-giridharisharan-dev.json": [
		6881,
		[
			1753
		]
	],
	"./braj-ke-bhakt-part-2/kamyavan-ke-chhote-baba.json": [
		3129,
		[
			8563
		]
	],
	"./braj-ke-bhakt-part-2/madan-ter-ke-andhe-baba.json": [
		3957,
		[
			4111
		]
	],
	"./braj-ke-bhakt-part-2/mahakavi-goswami-shri-nandkishorchandra.json": [
		2371,
		[
			4673
		]
	],
	"./braj-ke-bhakt-part-2/mauni-baba.json": [
		688,
		[
			5616
		]
	],
	"./braj-ke-bhakt-part-2/mukhiya-shri-gokuldas.json": [
		4689,
		[
			3907
		]
	],
	"./braj-ke-bhakt-part-2/pandit-shyamsundar.json": [
		3219,
		[
			3687
		]
	],
	"./braj-ke-bhakt-part-2/shri-amolkaram-shastri.json": [
		7058,
		[
			6830
		]
	],
	"./braj-ke-bhakt-part-2/shri-dayaldas-babaji.json": [
		8741,
		[
			4513
		]
	],
	"./braj-ke-bhakt-part-2/shri-devkinandan-goswami-prabhupad.json": [
		8737,
		[
			7709
		]
	],
	"./braj-ke-bhakt-part-2/shri-gadadhar-das-babaji.json": [
		7293,
		[
			2701
		]
	],
	"./braj-ke-bhakt-part-2/shri-gaur-govinddas-babaji.json": [
		3889,
		[
			1629
		]
	],
	"./braj-ke-bhakt-part-2/shri-gaurangdas-babaji-2.json": [
		7876,
		[
			9740
		]
	],
	"./braj-ke-bhakt-part-2/shri-gaurangdas-babaji.json": [
		6383,
		[
			6963
		]
	],
	"./braj-ke-bhakt-part-2/shri-girija-devi.json": [
		541,
		[
			1365
		]
	],
	"./braj-ke-bhakt-part-2/shri-gopaldas-babaji-utsavi.json": [
		4908,
		[
			4586
		]
	],
	"./braj-ke-bhakt-part-2/shri-hansdas-babaji-aur-gopali-bai.json": [
		9209,
		[
			1353
		]
	],
	"./braj-ke-bhakt-part-2/shri-hare-krishnadas-babaji.json": [
		3723,
		[
			53
		]
	],
	"./braj-ke-bhakt-part-2/shri-hari-gopal-goswami.json": [
		6040,
		[
			3066
		]
	],
	"./braj-ke-bhakt-part-2/shri-haricharandas-babaji.json": [
		7031,
		[
			4001
		]
	],
	"./braj-ke-bhakt-part-2/shri-haridas-babaji.json": [
		9300,
		[
			250
		]
	],
	"./braj-ke-bhakt-part-2/shri-harisundar-bhaumik-bhuina.json": [
		5401,
		[
			617
		]
	],
	"./braj-ke-bhakt-part-2/shri-hit-santdas-babaji.json": [
		6800,
		[
			6018
		]
	],
	"./braj-ke-bhakt-part-2/shri-hitkishorisharan-babaji-surdas.json": [
		2918,
		[
			9944
		]
	],
	"./braj-ke-bhakt-part-2/shri-jagannathdas-dadaji.json": [
		4286,
		[
			7566
		]
	],
	"./braj-ke-bhakt-part-2/shri-kamini-kumar-ghosh.json": [
		7196,
		[
			834
		]
	],
	"./braj-ke-bhakt-part-2/shri-krishna-chaitanyadas-baba-chandra-sarovar.json": [
		2407,
		[
			6568
		]
	],
	"./braj-ke-bhakt-part-2/shri-krishna-prasaddas-babaji.json": [
		2796,
		[
			9674
		]
	],
	"./braj-ke-bhakt-part-2/shri-madhusudan-goswamipad-sarvabhaum.json": [
		9246,
		[
			3752
		]
	],
	"./braj-ke-bhakt-part-2/shri-mauni-babaji.json": [
		1734,
		[
			9588
		]
	],
	"./braj-ke-bhakt-part-2/shri-narayan-swami.json": [
		5738,
		[
			2374
		]
	],
	"./braj-ke-bhakt-part-2/shri-nityananddas-babaji.json": [
		2940,
		[
			4756
		]
	],
	"./braj-ke-bhakt-part-2/shri-prankrishnadas-babaji.json": [
		1407,
		[
			4159
		]
	],
	"./braj-ke-bhakt-part-2/shri-premdas-babaji.json": [
		5942,
		[
			3288
		]
	],
	"./braj-ke-bhakt-part-2/shri-premmadhuri-bai.json": [
		4525,
		[
			6093
		]
	],
	"./braj-ke-bhakt-part-2/shri-ramananddas-babaji.json": [
		1850,
		[
			8856
		]
	],
	"./braj-ke-bhakt-part-2/shri-ramdas-babaji.json": [
		9706,
		[
			1058
		]
	],
	"./braj-ke-bhakt-part-2/shri-sadhu-maa.json": [
		979,
		[
			8899
		]
	],
	"./braj-ke-bhakt-part-2/shri-sakhicharandas-babaji-radhakund-vraj-bhakt-katha.json": [
		5549,
		[
			5459
		]
	],
	"./braj-ke-bhakt-part-2/shri-vaishnavdas-babaji.json": [
		1062,
		[
			1820
		]
	],
	"./braj-ke-bhakt-part-2/shri-vishwaroopdas-babaji.json": [
		2456,
		[
			238
		]
	],
	"./braj-ke-bhakt-part-2/shri-vrajkishordas-babaji-bhatrol.json": [
		6038,
		[
			2772
		]
	],
	"./braj-ke-bhakt-part-2/swami-shri-bhagwandas.json": [
		4326,
		[
			4976
		]
	],
	"./braj-ke-bhakt-part-2/swami-shri-govinddas.json": [
		3581,
		[
			5285
		]
	],
	"./braj-ke-bhakt-part-2/swami-shri-swaminisharan.json": [
		7951,
		[
			3403
		]
	],
	"./braj-ke-bhakt-part-3/balbhakt-shri-omprakash.json": [
		9373,
		[
			2979
		]
	],
	"./braj-ke-bhakt-part-3/bhakt-dadar-rahman.json": [
		1671,
		[
			7983
		]
	],
	"./braj-ke-bhakt-part-3/bhakt-shri-bholanath-bhori-sakhi.json": [
		8137,
		[
			1253
		]
	],
	"./braj-ke-bhakt-part-3/bhakt-shri-navalkishor-das.json": [
		435,
		[
			8487
		]
	],
	"./braj-ke-bhakt-part-3/bhakt-shri-snehiram.json": [
		3633,
		[
			2383
		]
	],
	"./braj-ke-bhakt-part-3/bhaktimati-shri-gopi-maa.json": [
		9531,
		[
			9963
		]
	],
	"./braj-ke-bhakt-part-3/bhaktimati-shri-karmi-bai.json": [
		3735,
		[
			2497
		]
	],
	"./braj-ke-bhakt-part-3/bhaktimati-shri-nathiya-bai.json": [
		9157,
		[
			5711
		]
	],
	"./braj-ke-bhakt-part-3/bhaktpravar-shri-radhikadas-maharaj.json": [
		569,
		[
			6687
		]
	],
	"./braj-ke-bhakt-part-3/goswami-shri-galluji-maharaj.json": [
		4000,
		[
			468
		]
	],
	"./braj-ke-bhakt-part-3/karta-shri-krishnadas-babaji.json": [
		1357,
		[
			2185
		]
	],
	"./braj-ke-bhakt-part-3/muslim-bhakt-gulab-sakhi.json": [
		4407,
		[
			9955
		]
	],
	"./braj-ke-bhakt-part-3/pandit-ramkrishna-das-babaji.json": [
		9512,
		[
			5304
		]
	],
	"./braj-ke-bhakt-part-3/pandit-shri-jagannathprasad-bhaktmali.json": [
		6823,
		[
			5981
		]
	],
	"./braj-ke-bhakt-part-3/rajarshi-shri-vanmali-rai-bahadur.json": [
		6087,
		[
			3529
		]
	],
	"./braj-ke-bhakt-part-3/shri-ac-bhaktivedanta-swami-prabhupad.json": [
		8934,
		[
			4556
		]
	],
	"./braj-ke-bhakt-part-3/shri-advaitdas-babaji.json": [
		1216,
		[
			4034
		]
	],
	"./braj-ke-bhakt-part-3/shri-anantdas-babaji.json": [
		6559,
		[
			4471
		]
	],
	"./braj-ke-bhakt-part-3/shri-bairu-babaji.json": [
		8514,
		[
			5992
		]
	],
	"./braj-ke-bhakt-part-3/shri-chaitanyadas-babaji.json": [
		2101,
		[
			2965
		]
	],
	"./braj-ke-bhakt-part-3/shri-gopaldas-babaji.json": [
		2160,
		[
			3156
		]
	],
	"./braj-ke-bhakt-part-3/shri-hari-babaji.json": [
		1381,
		[
			3745
		]
	],
	"./braj-ke-bhakt-part-3/shri-ishwardas-babaji.json": [
		1995,
		[
			1601
		]
	],
	"./braj-ke-bhakt-part-3/shri-jagdishdas-babaji.json": [
		4081,
		[
			7265
		]
	],
	"./braj-ke-bhakt-part-3/shri-jugaldas-babaji-2.json": [
		4387,
		[
			207
		]
	],
	"./braj-ke-bhakt-part-3/shri-jugaldas-babaji.json": [
		1516,
		[
			8087
		]
	],
	"./braj-ke-bhakt-part-3/shri-kripasindhudas-babaji-2.json": [
		2126,
		[
			678
		]
	],
	"./braj-ke-bhakt-part-3/shri-kripasindhudas-babaji.json": [
		9541,
		[
			9249
		]
	],
	"./braj-ke-bhakt-part-3/shri-krishnaprem-ronald-nixon-aur-maa-yashoda.json": [
		1962,
		[
			2052
		]
	],
	"./braj-ke-bhakt-part-3/shri-kunjdas-babaji.json": [
		5237,
		[
			5227
		]
	],
	"./braj-ke-bhakt-part-3/shri-lalitkishori-aur-lalitmadhuri.json": [
		4070,
		[
			1882
		]
	],
	"./braj-ke-bhakt-part-3/shri-madanmohandas-babaji.json": [
		7605,
		[
			3
		]
	],
	"./braj-ke-bhakt-part-3/shri-madhavdas-babaji-2.json": [
		8495,
		[
			1341
		]
	],
	"./braj-ke-bhakt-part-3/shri-madhavdas-babaji.json": [
		1536,
		[
			1750
		]
	],
	"./braj-ke-bhakt-part-3/shri-mauni-babaji-2.json": [
		7230,
		[
			272
		]
	],
	"./braj-ke-bhakt-part-3/shri-phool-babaji.json": [
		2275,
		[
			9689
		]
	],
	"./braj-ke-bhakt-part-3/shri-pramanand-goswami-prabhupad.json": [
		3707,
		[
			4323
		]
	],
	"./braj-ke-bhakt-part-3/shri-priyasharan-babaji.json": [
		4885,
		[
			9647
		]
	],
	"./braj-ke-bhakt-part-3/shri-radhamohandas-babaji.json": [
		7774,
		[
			4020
		]
	],
	"./braj-ke-bhakt-part-3/shri-radharaman-das-babaji.json": [
		7501,
		[
			3265
		]
	],
	"./braj-ke-bhakt-part-3/shri-ramdas-kathiya-baba.json": [
		6994,
		[
			7798
		]
	],
	"./braj-ke-bhakt-part-3/shri-ramkrishnadas-babaji.json": [
		4171,
		[
			2070
		]
	],
	"./braj-ke-bhakt-part-3/shri-santdas-kathiya-baba.json": [
		3562,
		[
			424
		]
	],
	"./braj-ke-bhakt-part-3/shri-satyaharidas-babaji.json": [
		2551,
		[
			3587
		]
	],
	"./braj-ke-bhakt-part-3/shri-shachinandan-das-baba.json": [
		9485,
		[
			8073
		]
	],
	"./braj-ke-bhakt-part-3/shri-subaldas-babaji.json": [
		5892,
		[
			9908
		]
	],
	"./braj-ke-bhakt-part-3/shri-swami-baldevdas-ji.json": [
		8401,
		[
			727
		]
	],
	"./braj-ke-bhakt-part-3/shri-swami-kokil.json": [
		7889,
		[
			6717
		]
	],
	"./braj-ke-bhakt-part-3/shri-swami-roopmadhurisharan-ji.json": [
		3946,
		[
			848
		]
	],
	"./braj-ke-bhakt-part-3/shri-yadunandandas-babaji.json": [
		7608,
		[
			4446
		]
	],
	"./braj-ke-bhakt-part-3/shri-yashoda-mai.json": [
		616,
		[
			6296
		]
	],
	"./braj-ke-bhakt-part-3/swami-shri-balmukunddas.json": [
		4672,
		[
			3622
		]
	],
	"./braj-ke-bhakt-part-3/swami-shri-krishnananddas.json": [
		2214,
		[
			4724
		]
	],
	"./shri-krishna-bal-leela/aghasur-vadh-vanbhoj-krishna.json": [
		9567,
		[
			2395
		]
	],
	"./shri-krishna-bal-leela/akashvani-kans-devki-vasudev.json": [
		4335,
		[
			8307
		]
	],
	"./shri-krishna-bal-leela/akrur-ke-saath-kans-vrindavan-nimantran.json": [
		661,
		[
			4347
		]
	],
	"./shri-krishna-bal-leela/arishtasur-vadh-krishna-sand.json": [
		1878,
		[
			9182
		]
	],
	"./shri-krishna-bal-leela/bakasur-vadh-krishna-yamuna.json": [
		4048,
		[
			2438
		]
	],
	"./shri-krishna-bal-leela/bhim-ka-prahar-jarasandh-malla-yuddh.json": [
		6870,
		[
			6674
		]
	],
	"./shri-krishna-bal-leela/brahma-ki-maya-krishna-leela.json": [
		8174,
		[
			5362
		]
	],
	"./shri-krishna-bal-leela/devi-durga-ki-chetavani-kans.json": [
		9777,
		[
			925
		]
	],
	"./shri-krishna-bal-leela/dhenukasur-vadh-balram-krishna.json": [
		2543,
		[
			9379
		]
	],
	"./shri-krishna-bal-leela/dwarka-ka-nirman-kalyavan-vadh.json": [
		9321,
		[
			3997
		]
	],
	"./shri-krishna-bal-leela/dwarka-me-sunand-krishna-ko-rukmini-ka-patra.json": [
		87,
		[
			6691
		]
	],
	"./shri-krishna-bal-leela/gandharva-ki-mukti-krishna-nand-ajgar.json": [
		9681,
		[
			4447
		]
	],
	"./shri-krishna-bal-leela/gokul-mein-jeevan-krishna-namkaran.json": [
		5201,
		[
			7605
		]
	],
	"./shri-krishna-bal-leela/gokul-pahunchna-nand-vasudev.json": [
		7596,
		[
			1308
		]
	],
	"./shri-krishna-bal-leela/govardhan-dharan-krishna.json": [
		8028,
		[
			1788
		]
	],
	"./shri-krishna-bal-leela/jarasandh-ki-maut-bhim-krishna-tinka.json": [
		4963,
		[
			3987
		]
	],
	"./shri-krishna-bal-leela/jarasandh-ki-pratigya-krishna-balram-yuddh.json": [
		8867,
		[
			2171
		]
	],
	"./shri-krishna-bal-leela/jarasandh-ki-vijay-pravarshan-parvat.json": [
		6957,
		[
			3621
		]
	],
	"./shri-krishna-bal-leela/jungle-ki-aag-krishna-gopalak.json": [
		3435,
		[
			9801
		]
	],
	"./shri-krishna-bal-leela/kaliya-nag-ka-darp-daman.json": [
		4997,
		[
			5293
		]
	],
	"./shri-krishna-bal-leela/kans-ke-liye-apshakun-dhanush-toota.json": [
		2514,
		[
			5944
		]
	],
	"./shri-krishna-bal-leela/kans-ki-mrityu-krishna-balram-mathura.json": [
		205,
		[
			9523
		]
	],
	"./shri-krishna-bal-leela/keshasur-vadh-krishna-ghoda.json": [
		6683,
		[
			1137
		]
	],
	"./shri-krishna-bal-leela/krishna-aur-balram-gokul.json": [
		2616,
		[
			2880
		]
	],
	"./shri-krishna-bal-leela/krishna-aur-brahman-striyan.json": [
		7994,
		[
			4944
		]
	],
	"./shri-krishna-bal-leela/krishna-aur-mur-daanav-vadh.json": [
		4392,
		[
			726
		]
	],
	"./shri-krishna-bal-leela/krishna-aur-mur.json": [
		2914,
		[
			7892
		]
	],
	"./shri-krishna-bal-leela/krishna-aur-narakasur.json": [
		3948,
		[
			3270
		]
	],
	"./shri-krishna-bal-leela/krishna-aur-rukmini-vidarbha-jarasandh.json": [
		1356,
		[
			1904
		]
	],
	"./shri-krishna-bal-leela/krishna-aur-shishupal-sau-apradh.json": [
		744,
		[
			5456
		]
	],
	"./shri-krishna-bal-leela/krishna-aur-sudama.json": [
		9815,
		[
			8995
		]
	],
	"./shri-krishna-bal-leela/krishna-jambvati-satyabhama.json": [
		8897,
		[
			6571
		]
	],
	"./shri-krishna-bal-leela/krishna-ka-vidarbha-jana-rukmini-haran.json": [
		7105,
		[
			3013
		]
	],
	"./shri-krishna-bal-leela/krishna-leela-ka-samapan.json": [
		4877,
		[
			7313
		]
	],
	"./shri-krishna-bal-leela/krishna-rasleela-sharad-purnima.json": [
		3121,
		[
			7827
		]
	],
	"./shri-krishna-bal-leela/krishna-rukmini-ka-vivah-dwarka.json": [
		5261,
		[
			4255
		]
	],
	"./shri-krishna-bal-leela/krishna-shatdhanva-akrur.json": [
		3805,
		[
			1029
		]
	],
	"./shri-krishna-bal-leela/kubalayapeed-ki-maut-krishna-balram-hathi.json": [
		9537,
		[
			491
		]
	],
	"./shri-krishna-bal-leela/kuber-ke-putra-nalkuber-manigriv.json": [
		9498,
		[
			6350
		]
	],
	"./shri-krishna-bal-leela/mani-ka-khona-prasenjit-jambvant.json": [
		5127,
		[
			3911
		]
	],
	"./shri-krishna-bal-leela/mani-ki-khoj-krishna-jambvant-yuddh.json": [
		9285,
		[
			2987
		]
	],
	"./shri-krishna-bal-leela/mathura-gaman-krishna-balram-akrur.json": [
		1256,
		[
			4276
		]
	],
	"./shri-krishna-bal-leela/mathura-mein-krishna-dhobi-sudama-trivakra-dhanush.json": [
		7789,
		[
			2429
		]
	],
	"./shri-krishna-bal-leela/narad-kans-ke-paas-dhanurya-gya-yojana.json": [
		5139,
		[
			171
		]
	],
	"./shri-krishna-bal-leela/narakasur-ki-mrityu.json": [
		9464,
		[
			7902
		]
	],
	"./shri-krishna-bal-leela/natkhat-krishna-makhan-chor.json": [
		4336,
		[
			2674
		]
	],
	"./shri-krishna-bal-leela/phalon-ki-tokri-krishna.json": [
		7078,
		[
			3424
		]
	],
	"./shri-krishna-bal-leela/pralamb-vadh-balram.json": [
		5369,
		[
			9951
		]
	],
	"./shri-krishna-bal-leela/putana-vadh-krishna-gokul.json": [
		5521,
		[
			1075
		]
	],
	"./shri-krishna-bal-leela/rassi-ki-kahani-krishna-ukhal.json": [
		697,
		[
			6899
		]
	],
	"./shri-krishna-bal-leela/rukmini-ka-krishna-prem-sunand-sandesh.json": [
		7301,
		[
			3677
		]
	],
	"./shri-krishna-bal-leela/shankhchud-vadh-krishna-balram.json": [
		4628,
		[
			4660
		]
	],
	"./shri-krishna-bal-leela/shrikrishna-ka-janm.json": [
		3386,
		[
			2948
		]
	],
	"./shri-krishna-bal-leela/syamantak-mani-satrajit-surya-dev.json": [
		4391,
		[
			5077
		]
	],
	"./shri-krishna-bal-leela/tanashah-kans-devki-ke-putra.json": [
		7020,
		[
			3408
		]
	],
	"./shri-krishna-bal-leela/trinavart-vadh-krishna.json": [
		6872,
		[
			6252
		]
	],
	"./shri-krishna-bal-leela/vatsasur-vadh-krishna-vrindavan.json": [
		9728,
		[
			9530
		]
	],
	"./shri-krishna-bal-leela/vrindavan-ka-jeevan-krishna-balram.json": [
		2333,
		[
			6369
		]
	],
	"./shri-krishna-bal-leela/vrindavan-mein-basna-gokul-se-palayan.json": [
		3746,
		[
			4632
		]
	],
	"./shri-krishna-bal-leela/vyomasur-vadh-krishna-gufa.json": [
		7519,
		[
			5591
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 870;
module.exports = webpackAsyncContext;